import { io } from "socket.io-client";
import { getCookie } from "../cookie-storage/cookie-storage";

let socket = {};

export const connectSocket = (key, baseUrl) => {
  if (!socket[key] || socket[key].disconnected) {
    const socketUrl = baseUrl.replace(/^https/, 'wss');
    const userToken = getCookie("auth-token");

    socket[key] = io(socketUrl, {
      transports: ["websocket"],
      path: "/socket.io",
      auth: {
        token: userToken,
      },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
    });

    socket[key].on("connect", () => {
      console.log(`[${key}] Socket connected`);
    });

    socket[key].on("connect_error", (err) => {
      console.error(`[${key}] Socket connection error`, err);
    });

    socket[key].on("disconnect", () => {
      console.log(`[${key}] Socket disconnected`);
    });
  }

  return socket[key];
};

export const getSocket = (key) => socket[key];

export const disconnectSocket = (key) => {
  if (socket[key]) {
    socket[key].disconnect();
    delete socket[key];
  }
};
